/// <amd-module name="TFS/Admin/Views/ProfileSettings/AuthorizationsView/Components/ZeroDataAuthorizationView" />
import React = require("react");
import * as Resources from "TFS/Admin/Views/ProfileSettings/AuthorizationsView/Resources";
import { VssComponent } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Card } from "VSSUI/Card";
import { ZeroData } from "VSSUI/ZeroData";

const noResultsImage = "ms.vss-tfs-web/platform-content/Illustrations/general-no-results-found.svg";

export class ZeroDataAuthorizationView extends VssComponent<{}> {
    public render() {
        return (
            <Card className="auth-card-content" contentProps={{ contentPadding: false }}>
                <ZeroData
                    className="auth-zero-data"
                    imagePath={getAssetLocation(this.context.pageContext, noResultsImage)}
                    imageAltText={Resources.AuthNoDataAvailable}
                    primaryText={Resources.AuthNoDataAvailable}
                    aria-label={Resources.AuthNoDataAvailable}
                />
            </Card>
        );
    }
}
